import { useQuery } from '@pankod/refine-core';
import { getFeatureFlags } from 'services/feature-flag';
import { isFeatureEnabled } from 'utilities/menu-visibility';

const FIVE_MINUTES_IN_MILLISECONDS = 5 * 60 * 1000;

// Fetched on load, again whenever the window regains focus, and every five minutes, so a flag
// EloByte turns on or off reaches open tabs without a reload.
export const useFeatureFlags = () =>
  useQuery(['featureFlags'], getFeatureFlags, {
    refetchOnWindowFocus: true,
    refetchInterval: FIVE_MINUTES_IN_MILLISECONDS,
    staleTime: 60 * 1000,
  });

export const useFeatureFlag = (key: string) => {
  const { data: featureFlags } = useFeatureFlags();
  return isFeatureEnabled(featureFlags, key);
};
